
import React from 'react';
import { FormattedMessage } from 'react-intl/dist';
import classNames from 'classnames';

// Components

import UniversalSearchInput from './UniversalSearchInput';


const SearchRow = props => {
    const {
        handleInputChange,
        refresher,
        rowData,
        searchValues
    } = props;

    const getSearchColumns = () => {
        return rowData.map((column, idx) => {

            const {
                label,
                inputs
            } = column;

            const getInputs = () => {
                return inputs.map(input => {
                    return (
                        <UniversalSearchInput
                            key = { input.name }
                            { ...{
                                ...input,
                                handleInputChange,
                                refresher,
                                searchValues,
                                stretch: inputs.length < 2
                            } }
                        />
                    );
                });
            };

            const className = classNames(
                'search-input-label',
                { 'label-hidden': label === 'common.no' }
            );

            return (
                <div
                    key = { `${label}_${idx}` }
                    className = 'search-column desktop:grid-col-4'
                >
                    <div className = { className }>
                        <FormattedMessage id = { label }/>
                    </div>
                    <div className = 'grid-row'>
                        { getInputs() }
                    </div>
                </div>
            );
        });
    };

    return (
        <div className = 'search-row grid-row margin-bottom-1em'>
            { getSearchColumns() }
        </div>
    );
};

export default SearchRow;